define('disclosures',['require','exports','module'],function(require, exports, module) {
  module.exports = {
    data: [
      {
        templateTypeDescription: 'disclosure',
        displayName: 'Start a new <b>Annual</b> disclosure.',
      },
      {
        templateTypeDescription: 'research_disclosure',
        displayName: 'Start a new <b>Research-Based</b> disclosure.',
      },
    ],
  };
});

